import posthogClient from "posthog-js";

import { shouldDropChunkException } from "./chunk-reload-policy";
import { createPosthogBridge } from "./posthog-bridge";
import { CATEGORIES, onUnavailable, watchCategory } from "./termly";

// The reload policy owns its state without depending on the telemetry bridge.
export const {
  beforeSend,
  getFeatureFlagVariant,
  watchFeatureFlagVariant,
  init,
  applyOptIn,
  recordClsMutation,
  capture,
  captureException,
  captureMessage,
  setUser,
} = createPosthogBridge(
  posthogClient,
  { CATEGORIES, onUnavailable, watchCategory },
  shouldDropChunkException
);
